module.exports = __webpack_public_path__ + "9b21dde15de9cc5fddf09ea155845df5.png";